import { types, applySnapshot } from 'mobx-state-tree';
import { url } from 'js/services/Network';
import Navigation from './types/Navigation';

const defaultNav = {
  mode: 'normal',
  url: url('home-page'),
  text: 'Back',
};

export default types
  .model('AppState', {
    navigation: types.optional(Navigation, defaultNav),
    loginSignupVisible: types.optional(types.union(types.string, types.boolean), false),
    pageColor: 'transparent',
    loginRequired: false,
    loginDialogProps: types.optional(types.frozen(), {}),
    rolesRequired: types.array(types.string),
    currentPage: 'unknown',
    previousPage: types.maybe(types.string),
    booted: false,
    invalidSession: types.optional(types.union(types.boolean, types.string), false),
    msellerLogin: types.optional(types.union(types.boolean, types.string), false),
    showConfirmationCode: false,
    mseller: '',
  })
  .views(self => ({
    get isOnLandingPage() {
      return ['SellerLandingPage', 'BuyerLandingPage'].includes(self.currentPage);
    },
  }))
  .actions(self => ({
    afterCreate() {
      if (window.app.env !== 'production') {
        // window.AppState = self;
      }
      window.AppState = self;
    },
    invalidateSession() {
      self.invalidSession = true;
    },
    showLoginSignup(display = 'login',singleUseToken = '') {
      self.loginSignupVisible = display;
      return self;
    },
    hideLoginSignup() {
      self.loginSignupVisible = false;
      return self;
    },
    setDialogProps(props) {
      self.loginDialogProps = props;
      return self;
    },
    setMSellerLogin(msellerLogin) {
      self.msellerLogin = msellerLogin;
      return self;
    },
    setBooted(isBooted) {
      self.booted = isBooted;
      return self;
    },
    setNav(navigation = {}) {
      if (navigation && navigation !== 'preserve') {
        applySnapshot(self.navigation, Object.assign({}, defaultNav, navigation));
      }
      return self;
    },
    setLoginRequired(loginRequired) {
      self.loginRequired = loginRequired;
      return self;
    },
    setRolesRequired(roles) {
      self.rolesRequired = roles;
      return self;
    },
    setPageColor(pageColor) {
      self.pageColor = typeof pageColor.hex === 'function' ? pageColor.hex() : pageColor;
      return self;
    },
    setPreviousPage(page) {
      self.previousPage = page;
      return self;
    },
    setCurrentPage(currentPage) {
      self.previousPage = self.currentPage;
      self.currentPage = currentPage;
      return self;
    },
    setShowConfirmationCode(showConfirmationCode) {
      self.showConfirmationCode = showConfirmationCode;
      return self;
    },
    setMSeller(mseller) {
      self.mseller = mseller;
      return self;
    },
  }))
  .create();
